import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AutomationFilter } from 'src/components/AutomationTrading/AutomationTrading';
import { renderBetween } from 'src/components/AutomationTrading/AutomationItem/AutomationComponents/AutomationComponents';
import {
    FilterData,
    FilterKey,
    FilterWrapper,
    ItemsWrapper,
} from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import { EditableData } from 'src/components/AutomationTrading/AutomationItem/EditableData';
import { AutomationItemState } from 'src/components/AutomationTrading/AutomationItem/AutomationItem.state';
import { AutotraderAutomationFilterParametrizedType } from 'src/api_openapi/v2/automations/schemas';

type FiltersPropsType = {
    filters: AutotraderAutomationFilterParametrizedType | null;
    automationItemState: AutomationItemState;
};
export const ItemOptionalFilter = observer('Item Optional Filter', (props: FiltersPropsType) => {
    if (props.filters === null) {
        return null;
    }
    const buildFilter = (filter: AutomationFilter | undefined): JSX.Element | null => {
        if (filter === undefined) {
            return null;
        }
        switch (filter.kind) {
            case 'between':
                return renderBetween(filter);
            case 'in':
                return (
                    <ItemsWrapper>
                        <FilterData>{filter.in.field}</FilterData>{' '}
                        <EditableData
                            onSave={(event) =>
                                props.automationItemState.saveOptionalFilter(
                                    'in',
                                    props.filters?.name,
                                    filter.in.field,
                                    event
                                )
                            }
                            initValueOrState={props.automationItemState.parametrizedInput}
                        />
                    </ItemsWrapper>
                );
            case 'where':
                return (
                    <ItemsWrapper>
                        <FilterData>{filter.where.field}</FilterData> <FilterData>{filter.where.operator}</FilterData>{' '}
                        <EditableData
                            initValueOrState={props.automationItemState.parametrizedInput}
                            onSave={(event) =>
                                props.automationItemState.saveOptionalFilter(
                                    'where',
                                    filter.where.field,
                                    filter.where.field,
                                    event
                                )
                            }
                        />
                    </ItemsWrapper>
                );
        }
        return null;
    };

    return (
        <FilterWrapper>
            <FilterKey>{props.filters?.name}</FilterKey>
            {buildFilter(props.filters?.filter)}
        </FilterWrapper>
    );
});
